export const IOF = 0.0738;
export const ADJUST_VALUE = 0.931272;